import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ModalContainer, SideNav, TopNav } from 'Components/Partials/Layouts';

import { Sockets, Event } from 'Services';
import Holiday from 'Services/Api/HumanResource/Holiday';
import Me from 'Services/Api/Me/Me';
import NotificationsApi from 'Services/Api/Me/Notifications';
import SuspendedStockApi from 'Services/Api/SuspendedStock/SuspendedStock';
import OvertimeApi from 'Services/Api/Time/Overtime';

import AuthenticatedRouter from './AuthenticatedRouter';

import Main from './Main';

/**
 * @classdesc Authenticated handler
 */
export default class Authenticated extends Main {
    /**
     * @var state
     * @type {{collapse: boolean}}
     */
    state = {
        collapse: localStorage.getItem('collapse') == 1 ?? false,
        stats: {},
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.initStats();

        Sockets.connect(this.props.user.id);
        Sockets.notification(this.fetchStats);

        NotificationsApi.on('read', this.fetchStats);

        Holiday.on('approve', this.fetchStats);
        Holiday.on('reject', this.fetchStats);

        OvertimeApi.on('approve', this.fetchStats);
        OvertimeApi.on('reject', this.fetchStats);

        Event.on('refresh-stats', this.fetchStats);

        SuspendedStockApi.on('update', this.fetchStats);
    };

    initStats = () => {
        if (window.appBase?.stats) {
            return this.setState(this.setStats(window.appBase?.stats ?? {}));
        }

        this.fetchStats();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        NotificationsApi.removeListener('read', this.fetchStats);

        Holiday.removeListener('approve', this.fetchStats);
        Holiday.removeListener('reject', this.fetchStats);

        OvertimeApi.removeListener('approve', this.fetchStats);
        OvertimeApi.removeListener('reject', this.fetchStats);

        Event.removeListener('refresh-stats', this.fetchStats);

        SuspendedStockApi.removeListener('update', this.fetchStats);
    };

    setStats = (stats) => ({
        notifications: stats?.notifications,
        holidayApprovals: stats?.holiday_approvals,
        overtimeApprovals: stats?.overtime_approvals,
        suspendedStockPending: stats?.suspended_stock_pending,
        accidentLog: stats?.accident_log,
    });

    /**
     * @method handleToggleCollapse
     */
    handleToggleCollapse = () => {
        const collapse = !this.state.collapse;

        localStorage.setItem('collapse', `${collapse ? '1' : '0'}`);

        this.setState({
            collapse,
        });
    };

    /**
     * @method fetchStats
     */
    fetchStats = async () => {
        const request = await Me.stats();

        if (request.status !== 200) {
            return false;
        }

        this.setState(this.setStats(request.data.data));
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const { collapse, holidayApprovals, overtimeApprovals, suspendedStockPending, accidentLog, notifications } = this.state;

        return (
            <BrowserRouter>
                <div className="h-screen flex flex-col overflow-hidden bg-gray-100">
                    <TopNav
                        user={this.props.user}
                        notifications={notifications}
                        handleToggleCollapse={this.handleToggleCollapse}
                    />

                    <div className="flex flex-1 overflow-hidden">
                        <SideNav
                            holidayApprovals={holidayApprovals}
                            overtimeApprovals={overtimeApprovals}
                            suspendedStockPending={suspendedStockPending}
                            accidentLog={accidentLog}
                            collapse={collapse}
                            handleToggleCollapse={this.handleToggleCollapse}
                        />

                        <AuthenticatedRouter
                            user={this.props.user}
                        />
                    </div>

                    <ModalContainer
                        user={this.props.user}
                    />
                </div>
            </BrowserRouter>
        );
    };
}

